<template>
  <div id="monitoring">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-btn depressed
              color="primary"
              @click="dialog = true">
              {{$t('reports.filter')}}
              <v-icon small class="ml-2">
                fas fa-align-center
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadMonitoring"/>
            <v-data-table
              :headers="headers"
              :options.sync="optionsTable"
              :footer-props="{ 'items-per-page-options': [15, 50, 70, 100] }"
              :server-items-length="optionsTable.total"
              :loading="loadMonitoring"
              @update:page="getItems"
              @update:items-per-page="getItems"
              @update:sort-by="getItems"
              @update:sort-desc="getItems"
              :items="monitoring"
            >
              <template v-slot:item="props">
                <tr>
                  <td align="left">{{props.item.vin_number ? props.item.vin_number : '--'}}</td>
                  <td align="left">{{props.item.plates && props.item.plates.length > 0 ? props.item.plates[0].plate_number : '--'}}</td>
                  <td align="left">{{props.item.unit_number ? props.item.unit_number : '--'}}</td>
                  <td align="left">{{props.item.unit_types && props.item.unit_types.alias ? props.item.unit_types.alias : '--'}}</td>
                  <td align="left">{{props.item.sites_name}}</td>
                  <td align="left">{{$t(`units.${props.item.owner}`)}}<p v-if="props.item.owner === 'EXTERNAL'">{{props.item.owner_name ? `(${props.item.owner_name})` : ''}}</p></td>
                  <td align="left">{{$t(`units.${props.item.status}`) || '--'}}</td>
                  <td align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon 
                          small v-on="on"
                          @click="openDamage(props.item)">
                          mdi-eye-outline
                        </v-icon>
                      </template>
                      <span>{{$t('monitoring.seeDetailsReport')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Modal filtrado -->
    <v-dialog
      v-model="dialog"
      max-width="500px">
      <v-card>
        <v-card-title class="d-flex justify-space-between grey lighten-3">
          {{$t('reports.filter')}}
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-5"/>
        <v-card-text>
          <v-form lazy-validation ref="form">
            <v-row no-gutters>
                <!-- <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="unit.vin"
                  label="VIN"
                  class="mb-4"/> -->
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    :rules="rules.textNoSpecialCharsFilters"                  
                    v-model="unit.plaque"
                    :label="$t('monitoring.plaque')"
                    class="mb-4 ml-2"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="unit.number_economic"
                  :rules="rules.textNoSpecialChars"
                  :label="$t('monitoring.numberEconomic')"
                  class="mb-4 ml-2"/>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="unitTypes"
                    item-text="alias"
                    item-value="alias"
                    v-model="unit.alias"
                    :label="$t('monitoring.unit_type')"
                    class="mb-4 ml-2"/>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="siteCapitalizeWords"
                    item-text="name"
                    item-value="name"
                    v-model="unit.sites"
                    :label="$t('general.site')"
                    class="mb-4 ml-2"/>
                </v-col>
                <v-col cols="6" class="mt-n6">
                  <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="sitesList"
                  item-text="text"
                  item-value="name"
                  v-model="unit.property"
                  :label="$t('monitoring.property')"
                  class="mb-4 ml-2"/>
                </v-col>
                <v-col cols="6" class="mt-n6">
                  <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="stateList"
                  item-text="text"
                  item-value="name"
                  v-model="unit.state"
                  :label="$t('address.state')"
                  class="mb-4 ml-2"/>
                </v-col>
              <!-- <v-col cols="6">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  :return-value.sync="unit.date_start"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="unit.date_start"
                      :label="$t('general.startDate')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"/>
                  </template>
                  <v-date-picker
                    @input="menuStart = false"
                    v-model="unit.date_start"
                    scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col> -->
              <!-- <v-col cols="6">
                <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="unit.date_end"
                      :label="$t('general.endDate')"
                      class="mb-4 ml-2"
                      readonly
                      v-bind="attrs"
                      v-on="on"/>
                  </template>
                  <v-date-picker
                    @input="menuEnd = false"
                    v-model="unit.date_end"
                    scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions cols="6" class="mt-n8">
          <v-spacer/>
          <v-btn depressed color="primary" outlined @click="closeFilter">
            {{$t('general.cancel')}}
          </v-btn>
          <v-btn depressed
            @click="getFilter"
            color="primary">
            {{$t('general.search')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Monitoring',
  data () {
    return {
      loadMonitoring: false,
      monitoring: [],
      search: '',
      dialog: false,
      menuStart: false,
      menuEnd: false,
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      optionsTable: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      unit: {
        vin: '',
        plaque: '',
        number_economic: '',
        alias: '',
        sites: '',
        property: '',
        state: '',
        date_start: null,
        date_end: null
      },
      unitTypes: [],
      sites: [],
      sitesList: [
        { text: 'Propio', name: 'OWN' },
        { text: 'Externo (TI)', name: 'EXTERNAL' }
      ],
      stateList: [
        { text: 'Activo', name: 'ACTIVE' },
        { text: 'Inactivo', name: 'INACTIVE' },
        { text: 'En garaje', name: 'IN_GARAGE' }
      ]
    }
  },
  created () {
    this.getItems()
    this.$store.dispatch('unitTypes/getAll', {
      event: {
        context: this
      }
    })
    this.$store.dispatch('sites/get', {
      event: {
        context: this,
        item: {
        }
      }
    })
  },
  computed: {
    headers () {
      return [
        {
          text: 'VIN',
          value: 'vin_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.plaque'),
          value: 'plates',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.numberEconomic'),
          value: 'unit_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.unit_type'),
          value: 'unit_types',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.yard'),
          value: 'sites',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.property'),
          value: 'owner',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('address.state'),
          value: 'status',
          align: 'left',
          sortable: true
        },
        // {
        //   text: this.$t('monitoring.levelDamage'),
        //   value: 'level_damage',
        //   align: 'center',
        //   sortable: false
        // },
        // {
        //   text: this.$t('monitoring.inactiveDays'),
        //   value: 'inactive_days',
        //   align: 'center',
        //   sortable: false
        // },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    },
    siteCapitalizeWords() {
      if (this.sites.length === 0) return []

      return this.sites.map(site => {
        return {
          ...site,
          name: this.capitalizeWords(site.name)
        }
      })
    }
  },
  methods: {
    getFilter () {
      if(!this.$refs.form.validate()) return

      this.getItems()
      this.closeFilter()
    },
    closeFilter () {
      this.dialog = false
      this.unit.vin = '',
      this.unit.plaque = '',
      this.unit.number_economic = '',
      this.unit.alias = '',
      this.unit.sites = '',
      this.unit.property = '',
      this.unit.state = '',
      this.unit.date_start = null,
      this.unit.date_end = null
    },
    getItems() {
      this.loadMonitoring = true
      this.$store.dispatch('monitoring/getAllItems', {
        event: {
          context: this,
          plate_number: this.unit.plaque,
          unit_number: this.unit.number_economic,
          unit_types_alias: this.unit.alias,
          sites_name: this.unit.sites,
          owner: this.unit.property,
          status: this.unit.state,
          options: {
            perPage: this.optionsTable.itemsPerPage,
            page: this.optionsTable.page,
            find: this.search,
            sortKey: (this.optionsTable.sortBy && this.optionsTable.sortBy.length > 0) ? this.optionsTable.sortBy[0] : 'id',
            ord: this.optionsTable.sortDesc && this.optionsTable.sortDesc[0] ? 'asc' : 'desc'
          }
        }
      })
    },
    /** Metodo que permite ir a la vista de reporte de daños */
    openDamage (item) {
      const paramsUnit = JSON.stringify(item)
      localStorage.setItem('unit', paramsUnit)
      this.$router.push('/damage-report')
    },
    capitalizeWords(str) {
      if (!str) return ''
      
      return str
        .toLowerCase()
        .replace(/(^|\s)\p{L}/gu, c => c.toUpperCase());
    }
  }
}
</script>

<style>
</style>